module.exports = __webpack_public_path__ + "static/img/celio-screen.ddc4ee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/celio-screen.png
// module id = I8R4
// module chunks = 1